import { useEffect } from 'react'
import { Order } from '../../client/types/orders'
import { ConsentState } from '../../client/utils/onetrust-utils'
import { useGoogleAdsConversionTags, useMetaAdsConversionTags } from './ads'

/**
 * Hook for tracking order confirmation events to Google and Facebook
 */
export const useTrackOrderConfirmation = (
  completedOrder: Order | undefined,
  consentState: ConsentState
) => {
  const { data: googleData } = useGoogleAdsConversionTags()
  const { data: metaData } = useMetaAdsConversionTags()

  useEffect(() => {
    // Skip if no order or no targeting consent
    if (!completedOrder || !consentState.hasTargetingConsent) return

    const tax = completedOrder.checks[0].taxAmount
    const discount = completedOrder.checks[0].totalDiscountAmount
    const total = completedOrder.checks[0].totalAmount + discount - tax

    // COO Discover page tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16843855258/WEADCP-IsZkaEJqr498-',
        value: total,
        tax: tax,
        currency: 'USD',
        transaction_id: completedOrder.guid
      })

      // Restaurant-specific Google conversion tracking
      if (googleData?.conversionTagId && googleData?.eventLabel) {
        window.gtag('event', 'conversion', {
          send_to: `${googleData.conversionTagId}/${googleData.eventLabel}`,
          value: total,
          tax: tax,
          currency: 'USD',
          transaction_id: completedOrder.guid
        })
      }
    }

    // Facebook Pixel tracking
    if (window.fbq && metaData?.pixelId) {
      window.fbq('track', 'Purchase', {
        source_type: 'catering',
        action_source: 'website',
        partner_agent: 'Toast',
        value: total,
        currency: 'USD'
      })
    }
  }, [consentState.hasTargetingConsent, completedOrder, googleData, metaData])
}
